import React, { Component } from 'react';
import { connect } from "react-redux";
import service from './../services/paymentPartnersService';
import style from "./DetailsPayment.css";
import RowDetailPayment, { RowDetailDeterioro } from './RowDetailPayment.jsx';

class DetailsPayment extends Component {
    constructor(props) {
        super(props);
        this.state = {
            lists: [],
            recruiter: '',
            statusAllChecked: false,
            showDetailsTotal: false
        };

        this.fetchNominas = () => {
            const { selectedStartDate, selectedFinalDate, idPartner, clientId, ceco } = this.props;
            service.getDetailsPayment(selectedStartDate.format('YYYY-MM-DD'), selectedFinalDate.format('YYYY-MM-DD'), idPartner, clientId, ceco)
                .then(res => {
                    const data = res.data;
                    this.setState({ lists: data.lists, recruiter: data.recruiter });
                    this.checkValueAllCheckbox()
                })
                .catch(error => console.log(error));
        };

        this.checkValueAllCheckbox = () => {
            const status = this.state.lists.filter((list) => list.deterioroId == null).every(list => list.serviceStatusApproved === 4);
            this.setState({ statusAllChecked: status });
        };

        this.approvePayment = (idPartner, idList, status, callAllList) => {
            return service.updateApprovePayment(idPartner, idList, status)
                .then(() => callAllList ? this.fetchNominas() : null)
                .catch(error => console.log(error))
        };

        this.updateDtoAddReason = (idPartner, idList, value, reason) => {
            service.updateDtoAddReason(idPartner, idList, value, reason)
                .then(() => this.fetchNominas())
                .catch(error => console.log(error))
        };

        this.showDetailsTotal = () => {
            this.setState(prevState => ({ showDetailsTotal: !prevState.showDetailsTotal }))
        };

        this.handleChangeAll = (evt) => {
            const { lists } = this.state;
            const filterLists = lists.filter(list => !list.payrollStatus);
            const promises = filterLists.map(list => {
                return this.approvePayment(this.props.idPartner, list.listId, evt.target.checked, false);
            });

            Promise.all(promises)
                .then(() => this.fetchNominas())
                .catch(error => console.log(error));
        }
    }

    componentDidMount() {
        this.fetchNominas()
    }

    render() {
        let total = 0;
        const ids = this.state.lists.filter((list) => list.serviceStatusApproved == 4).map((list) => list.lisId)
        return (
            <table className={`table ${style.DetailsPayment}`}>
                <thead>
                    <tr>
                        <th scope="col">Fecha Inventario</th>
                        <th scope="col">CL</th>
                        <th scope="col">R</th>
                        <th scope="col">Comuna</th>
                        <th scope="col">Local</th>
                        <th scope="col">Base</th>
                        <th className={style.DetailsPayment__thDtoAdd} style={{ display: this.state.showDetailsTotal ? '' : 'none' }}>Dto/Add</th>
                        <th className={style.DetailsPayment__thComment} style={{ display: this.state.showDetailsTotal ? '' : 'none' }}>Motivo</th>
                        <th scope="col">Lider</th>
                        <th scope="col" onClick={this.showDetailsTotal}>
                            {'Monto '}
                            <span className="glyphicon glyphicon-edit"></span>
                        </th>
                        <th className={style.DetailsPayment__thStatus}>Nómina</th>
                        <th className={style.DetailsPayment__thStatus}></th>
                        <th scope="col">
                            <input
                                type="checkbox"
                                onClick={this.handleChangeAll}
                                checked={this.state.statusAllChecked}
                                disabled={!this.state.lists.filter(list => !list.payrollStatus).length > 0}
                            />
                        </th>
                        <th>Operador</th>
                    </tr>
                </thead>
                <tbody>
                    {this.state.lists.map((list, idx) => {
                        if (list.deterioroId != null) {
                            total -= list.deterioro.valor_imputable;
                            return <RowDetailDeterioro key={idx}
                                idx={idx}
                                list={list} />
                        }

                        if (list.serviceStatusApproved == 4) {
                            total += list.amount;
                        }
                        return <RowDetailPayment
                            key={idx}
                            idx={idx}
                            list={list}
                            idPartner={this.props.idPartner}
                            approvePayment={this.approvePayment}
                            showDetailsTotal={this.state.showDetailsTotal}
                            updateDtoAddReason={this.updateDtoAddReason}
                        />
                    })}
                </tbody>
                <tfoot>
                    <tr>
                        <td colSpan={7}></td>
                        <td>{total.toLocaleString("es-CL", { style: "currency", currency: "clp" })}</td>
                    </tr>
                </tfoot>
            </table>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        selectedStartDate: state.dateState.selectedStartDate,
        selectedFinalDate: state.dateState.selectedFinalDate
    };
};

export default connect(mapStateToProps, null)(DetailsPayment);


// WEBPACK FOOTER //
// ./frontEnd/treasury/payment-partners/components/DetailsPayment.jsx